export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-[#0D1B2A] to-black py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Left Column - Newsletter */}
          <div className="md:col-span-5">
            <h3 className="text-5xl font-light text-white mb-8">Stay Connected</h3>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              Get the latest updates on workshop innovations, team building insights, and exclusive offers.
            </p>
            <div className="flex flex-col gap-4">
              <input
                type="email"
                placeholder="Your email address"
                className="w-full px-6 py-4 bg-transparent border-b border-white/30 text-white text-base placeholder-gray-500 focus:outline-none focus:border-white transition-colors"
              />
              <button className="px-9 py-3 bg-white rounded-full text-black font-bold text-base hover:bg-cyan-400 hover:-translate-y-1 transition-all cursor-pointer flex items-center justify-center gap-2 whitespace-nowrap">
                Subscribe
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Middle Column - Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-cyan-400 text-sm font-semibold uppercase tracking-wider mb-6">
              Quick Links
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="#overview" className="text-white text-base hover:text-cyan-400 transition-colors cursor-pointer underline">
                  Workshop Overview
                </a>
              </li>
              <li>
                <a href="#technology" className="text-white text-base hover:text-cyan-400 transition-colors cursor-pointer underline">
                  Technology Features
                </a>
              </li>
              <li>
                <a href="#outcomes" className="text-white text-base hover:text-cyan-400 transition-colors cursor-pointer underline">
                  Outcomes &amp; Benefits
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white text-base hover:text-cyan-400 transition-colors cursor-pointer underline">
                  Request Proposal
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column - Contact */}
          <div className="md:col-span-4">
            <h4 className="text-cyan-400 text-sm font-semibold uppercase tracking-wider mb-6">
              Get In Touch
            </h4>
            <div className="space-y-4 mb-8">
              <p className="text-white text-lg">+65 1234 5678</p>
              <p className="text-white text-lg">hello@grooveandglow.sg</p>
            </div>
            
            <h4 className="text-cyan-400 text-sm font-semibold uppercase tracking-wider mb-6">
              Singapore Office
            </h4>
            <p className="text-white text-base leading-relaxed">
              123 Creative Drive<br />
              Singapore 123456
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Social Links */}
            <div className="flex items-center gap-6">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors underline cursor-pointer">
                LinkedIn
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors underline cursor-pointer">
                Instagram
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors underline cursor-pointer">
                YouTube
              </a>
            </div>

            {/* Copyright */}
            <p className="text-gray-400 text-sm text-center">
              © 2025 SkinS Team Building Workshop
            </p>

            {/* Policy Links */}
            <div className="flex items-center gap-6">
              <a href="/privacy" className="text-white hover:text-cyan-400 transition-colors underline cursor-pointer">
                Privacy Policy
              </a>
              <a href="/terms" className="text-white hover:text-cyan-400 transition-colors underline cursor-pointer">
                Terms of Service
              </a>
            </div>
          </div>

          {/* Attribution Link */}
          <div className="mt-8 text-center">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gray-500 text-sm hover:text-cyan-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
